import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface TpiConclusionDataState {
  TpiConclusionData: {
    load: boolean;
    data: [];
  };
}

export const TpiConclusionDataSlice = createSlice({
  name: "TpiConclusionData",
  initialState: {
    TpiConclusionData: {
      load: false,
      data: [],
    },
  } as TpiConclusionDataState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchTpiConclusionData.pending, (state: TpiConclusionDataState) => {
        state.TpiConclusionData.load = true;
      })
      .addCase(fetchTpiConclusionData.fulfilled, (state: TpiConclusionDataState, action: any) => {
        state.TpiConclusionData.data = action.payload;
        state.TpiConclusionData.load = false;
      })
      .addCase(fetchTpiConclusionData.rejected, (state: TpiConclusionDataState) => {
        state.TpiConclusionData.load = false;
      });
  },
});

export default TpiConclusionDataSlice.reducer;

export const fetchTpiConclusionData = createAsyncThunk(
  "TpiConclusionData/fetchTpiConclusionData",
  async (param: {apiParam: {project_pin: any, layout_id: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/getConclusionData", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id
      });
      return data.data;
    } catch (error) {
    }
  }
);
